import { render, staticRenderFns } from "./ContractOrderInfo.vue?vue&type=template&id=6a224b2f&scoped=true"
import script from "./ContractOrderInfo.vue?vue&type=script&lang=js"
export * from "./ContractOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractOrderInfo.vue?vue&type=style&index=0&id=6a224b2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a224b2f",
  null
  
)

export default component.exports